import { CHAT_CONVERSATION_TYPES } from "@/utils/constants";

export const PREDEFINED_MESSAGES = {
  [CHAT_CONVERSATION_TYPES.sale]: [
    { message: "Desculpe, já vendi!", id: 1 },
    { message: "Não aceito troca.", id: 2 },
    { message: "Faça uma proposta.", id: 3 },
    { message: "Ainda tem interesse?", id: 4 },
  ],
  [CHAT_CONVERSATION_TYPES.purchase]: [
    { message: "Ainda está disponível?", id: 1 },
    { message: "Consegue abaixar o preço?", id: 2 },
    { message: "Único dono?", id: 3 },
    { message: "Aceita troca?", id: 4 },
  ],
} as Record<string, Array<{ message: string; id: number }>>;
